import { useState } from 'react';
import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/ui/Hero';
import FilterSection from './components/FilterSection';
import NewsGrid from './components/NewsGrid';
import NewsletterSection from './components/NewsletterSection';

export default function NewsPage() {
  const [selectedCategory, setSelectedCategory] = useState('All Insights');
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero 
        subtitle="Uncovering the Future of Digital"
        title={<>Your Source for <span className="gradient-text">What's Next</span></>}
        description="Dive into the latest trends, expert analysis, and Hash Adz updates in AI, marketing, Web3, and beyond."
        bgImage="/assets/modern-digital-innovation.png"
        primaryBtn={{ text: "Explore Latest Insights", link: "#insights" }}
      />
      <FilterSection 
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />
      <NewsGrid 
        selectedCategory={selectedCategory}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
      <NewsletterSection />
      <Footer />
    </div>
  );
}